import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
	blockProcedureLabel: {
		fontWeight: theme.typography.fontWeightBold,
		color: theme.palette.primary.dark,
	},
	nonBlockProcedureLabel: {
		fontWeight: theme.typography.fontWeightBold,
		color: theme.palette.secondary.dark,
	},
}));

export const SurgeonEventTitle: React.FC<{ isBlock: boolean }> = ({ isBlock, children }) => {
	const classes = useStyles();
	return (
		<Typography
			variant="body2"
			className={classNames({
				[classes.blockProcedureLabel]: isBlock,
				[classes.nonBlockProcedureLabel]: !isBlock,
			})}
		>
			{children}
		</Typography>
	);
};
